import React, { useRef, useState } from 'react';
import styles from './VideoPlayer.module.css';
import videoFile from '../../assets/fruit-vid.mp4';

import { FaPlay, FaPause  } from "react-icons/fa";

const VideoPlayer = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className={styles.container} onClick={togglePlay}>
      <video ref={videoRef} className={styles.video} loop autoPlay muted>
        <source src={videoFile} type="video/mp4" />
      </video>

      {/* Center Icon */}
      <div className={styles.overlay}>
        {isPlaying ? <FaPause size={40} color="#fff" /> : <FaPlay size={40} color="#fff" />}
      </div>
    </div>
  );
};

export default VideoPlayer;